// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq__1Snly","contentContainer":"contentContainer__38VpA","longTitle":"longTitle__CIvZK","shortTitle":"shortTitle__2A1WA"};